import { useWsGet } from "@onefront/workspace-forms";

interface ParamsFetch {
    headers?: any;
}

interface IuseGetBusinessList {
    (workspaceId?: string, lazy?: boolean): {
        data?: any;
        loading?: boolean;
        fetch?: (fetchConfig?: ParamsFetch) => Promise<any>;
    };
}

export const useGetBusinessList: IuseGetBusinessList = (workspaceId, lazy = false) => {
    return useWsGet(`rnd:core:workspace-bff:api://v1/workspace/${workspaceId}/business`, {
        lazy
    });
};
